export const LOCATION_TREE_URL = "/location/location/decendents/tree";
